import React from 'react'
import { Link } from 'react-router'
import { config } from 'config'
import Footer from '../components/Footer'
import Header from '../components/Header'
import ReactGA from 'react-ga'

class Template extends React.Component {
  componentDidMount() {
    const { location, children } = this.props;
    if (process.env.NODE_ENV === 'production') {
      ReactGA.initialize(config.ga);
      ReactGA.set({ page: location.pathname });
      ReactGA.pageview(location.pathname);
    }
  }

  render () {
    const { location, children } = this.props;
    if (process.env.NODE_ENV === 'production') {
      ReactGA.set({ page: location.pathname });
      ReactGA.pageview(location.pathname);
    }
    return (
      <div className="parallax" ref={el => (this.instance = el)}>
        <Header pathname={location.pathname}/>
        {children}
        <Footer/>
      </div>
    )
  }
}

Template.propTypes = {
  children: React.PropTypes.any,
  location: React.PropTypes.object,
  route: React.PropTypes.object,
}

export default Template



// WEBPACK FOOTER //
// ./_template.js